var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',[(_vm.$route.name === _vm.$constants.ROUTE_NAMES.DSTV_INDEX)?_c('dstv-order-alert'):(_vm.canInstallApp)?_c('install-alert'):(!_vm.user)?_c('auth-alert'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }